export function shouldSkipAnswerDndWrapperRender(prevProps, nextProps) {
    const isDragging = typeof window !== 'undefined' && window.isDragging

    return (
        nextProps.deleteLocalItem == prevProps.deleteLocalItem &&
        nextProps.ix == prevProps.ix &&
        nextProps?.answer?.id == prevProps?.answer?.id &&
        nextProps?.answer?.updated_at == prevProps?.answer?.updated_at &&
        nextProps?.answer?.draft_answer_id == prevProps?.answer?.draft_answer_id &&
        nextProps?.answer?.position == prevProps?.answer?.position &&
        nextProps?.isActive == prevProps?.isActive &&
        nextProps?.isThin == prevProps?.isThin &&
        nextProps?.isTitle == prevProps?.isTitle &&
        nextProps?.isQuoteGuest == prevProps?.isQuoteGuest &&
        nextProps?.prevAnswerId == prevProps?.prevAnswerId &&
        nextProps?.nextAnswer?.id == prevProps?.nextAnswer?.id &&
        nextProps?.nextAnswer?.quest_id == prevProps?.nextAnswer?.quest_id &&
        nextProps?.nextAnswer?.reply_to_answer_id == prevProps?.nextAnswer?.reply_to_answer_id &&
        nextProps?.composerQuoteAnswerId == prevProps?.composerQuoteAnswerId &&
        nextProps?.onQuoteInPlace == prevProps?.onQuoteInPlace &&
        nextProps?.composerAlwaysInReach == prevProps?.composerAlwaysInReach &&
        nextProps?.quoteCount == prevProps?.quoteCount &&
        nextProps?.headQuoteCount == prevProps?.headQuoteCount &&
        nextProps?.replyCard == prevProps?.replyCard &&
        nextProps?.dmChatRun == prevProps?.dmChatRun &&
        nextProps?.dmChatDay == prevProps?.dmChatDay &&
        nextProps?.textIsCollapsed == prevProps?.textIsCollapsed &&
        nextProps?.COLLAPSE_POST_LENGTH == prevProps?.COLLAPSE_POST_LENGTH &&
        !isDragging
    )
}
